import { buildApiUrl } from '../../../../shared_app/utils/buildApiUrl';
export var COMMON_API = {
    auth: buildApiUrl('/api/auth'),
    grades: buildApiUrl('/api/references/grades'),
    skills: buildApiUrl('/api/references/skills'),
    domains: buildApiUrl('/api/references/domains'),
    assignmentSkills: buildApiUrl('/api/references/assignment_skills'),
    standards: buildApiUrl('/api/references/standards'),
    events: buildApiUrl('/api/teachers/events'),
    postSeenCardsSessions: buildApiUrl("/api/teachers/students/:studentId/mark_seen"),
};
